module.exports = __webpack_public_path__ + "onboarding-feed-myget.616163bd692324db50f3f3764ec32d8c.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/library/empty/onboarding-feed-myget.svg
// module id = 3289550993309761
// module chunks = 1